__turbopack_context__.v({
  "cardBody": "d1VfTa_cardBody",
  "cardTitle": "d1VfTa_cardTitle",
  "sectionBody": "d1VfTa_sectionBody",
  "sectionHeading": "d1VfTa_sectionHeading",
  "sectionLabel": "d1VfTa_sectionLabel",
  "sectionTextBlock": "d1VfTa_sectionTextBlock",
});
